import React from 'react';
import SubscribeIcon from '../../../../assets/images/modal-subscribe-now.png';

/**
 * Subscribe popup
 * @param setShow function to close the popup
 */
export const SubscribePopup = ({ setShow }) => {
	const redirectToAccounts = () => {
		location.assign('/accounts');
	};

	return (
		<div className="subscribe-popup">
			<div className="background-filter" onClick={() => setShow(false)} />
			<div className="subscribe-popup-container">
				<i
					id="close-button"
					className="fas fa-times float-right"
					onClick={() => setShow(false)}
				/>

				<h3 className="header-font">
					Join the #1 platform for brand partnerships
				</h3>
				<div className="left-side">
					<img src={SubscribeIcon} alt="Subscribe Now Image" />
				</div>
				<div className="right-side">
					<p className="body-font">
						Find the right partners that match your audience
					</p>
					<p className="body-font">
						Connect with partners and manage your conversations all
						in one place
					</p>
					<p className="body-font">
						Gain meaningful insight into the success of your
						partnerships
					</p>
				</div>
				<div className="subscribe-button" onClick={redirectToAccounts}>
					<p className="purchase-button">SUBSCRIBE NOW</p>
				</div>
			</div>
		</div>
	);
};
